import { jsx as t, jsxs as s } from "react/jsx-runtime";
import { ConfigProvider as i, Loader as a } from "@repo/go-ui";
import { useTranslation as u } from "react-i18next";
import { createContext as c, useMemo as d, useEffect as l, useContext as g } from "react";
import { e as h, b as f, c as m, g as p, r as x } from "./tokens-C4KyVSzL.js";
const r = c(null), b = ({ client: e, children: o }) => {
  const n = d(
    () => ({
      client: e,
      getAccessToken: p,
      getRefreshToken: m,
      getIdToken: f,
      getIsTokenExpired: h,
      logout: () => e.logout(),
      updateToken: () => e.updateToken(),
      login: () => e.login()
    }),
    [e]
  );
  return /* @__PURE__ */ t(r.Provider, { value: n, children: o });
};
function y() {
  const e = g(r);
  if (!e)
    throw new Error("useAuth must be used within AuthProvider");
  return e;
}
const E = ({ redirectTo: e = "/" }) => {
  const { t: o } = u();
  l(() => {
    try {
      x();
    } catch {
    }
    window.location.replace(e);
  }, [e]);
  const n = o("signingOut");
  return /* @__PURE__ */ t(
    i,
    {
      config: {
        theme: "dark",
        style: "bordered",
        size: "s"
      },
      externalElement: document.body,
      children: /* @__PURE__ */ s(
        "div",
        {
          style: {
            position: "relative",
            width: "100%",
            height: "100vh"
          },
          children: [
            /* @__PURE__ */ t(a, { size: "l" }),
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  position: "absolute",
                  left: "50%",
                  top: "calc(50% + 48px)",
                  transform: "translateX(-50%)",
                  zIndex: 1,
                  textAlign: "center",
                  fontSize: 16,
                  fontWeight: 600,
                  color: "var(--go-text)",
                  pointerEvents: "none",
                  whiteSpace: "nowrap"
                },
                children: n
              }
            )
          ]
        }
      )
    }
  );
};
export {
  b as AuthProvider,
  E as LogoffPage,
  y as useAuth
};
//# sourceMappingURL=react.es.js.map
